import { IInstrumentProperty } from "./InstrumentPropertyData";
import IInstrumentTypeData from "./InstrumentTypeData";
import IDirectionData from "../direction/directionData";
import INetworkConnectionData from "../networkConnection/NetworkConnectionData";

export default interface IInstrumentFormData {
    isEditMode: boolean;
    requestId: string;
    id: string;
    name: string;
    codeId: string;
    serialNumber: string;
    instrumentType: IInstrumentTypeData;
    directions: IDirectionData[];
    properties: IInstrumentProperty[];
    description: string;
    isCreatedManually: boolean;
    
}

export class InstrumentFormData implements IInstrumentFormData {
    isEditMode: boolean;
    requestId: string;
    id: string;
    name: string;
    codeId: string;
    serialNumber: string;
    instrumentType: IInstrumentTypeData;
    directions: IDirectionData[];
    properties: IInstrumentProperty[];
    description: string;
    isCreatedManually: boolean;
    

    constructor(isEditMode: boolean, requestId: string, id: string, name: string, codeId: string,
        serialNumber: string,
        instrumentType: IInstrumentTypeData,
        directions: IDirectionData[],
        properties: IInstrumentProperty[],
        description: string,
        isCreatedManually: boolean) {

        this.isEditMode = isEditMode;
        this.requestId = requestId;
        this.id = id;
        this.name = name;
        this.codeId = codeId;
        this.serialNumber = serialNumber;
        this.instrumentType = instrumentType;
        this.directions = directions;
        this.properties = properties;
        this.description = description;
        this.isCreatedManually = isCreatedManually
        

    }
}
const defaultInstrumentFormData = new InstrumentFormData(false, "", "", "", "", "",
    { id: "", name: "", description: "" }, [], [], "", false);
export { defaultInstrumentFormData };